<template>
  <div>
    <top />
    <div class="body">
      <div class="head">
        <h2>代行手数料</h2>
        <p>
          こちらのサイトは無在庫をメインに代行サービスを提供するサイトです。
          基本代行手数料は一律商品１点につき１５元になります。
        </p>
        <p>詳細：</p>
        <p>1. 詳細検品</p>
        <p>2. OPP無料交換</p>
        <p>3. 買い付け手数料込み</p>
        <p>4. ピッキング（発送）手数料込み</p>
        <p>※倉庫保管商品につきましては、60日間は無料で保管させていただきます。<br>
          資材（タグ、サンキューカードなど）等につきましては、基本的に制限はございません。</p>
        <p>なお、保管期間を超過した場合は、発送または廃棄のご連絡を差し上げますが、 <br>
          １週間以上ご返信をいただけない場合は、<br>
          自動的に廃棄処理をさせていただきますので、あらかじめご了承ください。</p>
      </div>
      <div class="main">
        <h2>自動見積りツール</h2>
        <div class="row">
          <div class="label">商品金額（元）</div>
          <div class="ipt">
            <input type="number" v-model="price" @input="calculatePrice" />
          </div>
        </div>
        <div class="row">
          <div class="label">予想商品合計重量（KG）</div>
          <div class="ipt">
            <el-select v-model="value" @change="calculateFreight">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="label">件数</div>
          <p>※手数料１件15元 （検品、買い付け、ピッキング費用　含む）</p>
          <div class="ipt">
            <input type="number" v-model="num" @input="calculateNum" />
          </div>
        </div>
        <div class="row">
          <div class="label">レート</div>
          <p>※変動レート</p>
          <div class="ipt">
            <input type="number" v-model="rate" @input="calculatePrice" />
          </div>
        </div>
        <!-- 金额 -->
        <div class="money">
          <div class="money-box">
            <div class="item">
              <div class="label">商品代金</div>
              <div class="ipt" :class="{ black: priceJP }">
                {{ priceJP }} <span>円</span>
              </div>
            </div>
            <div class="item">
              <div class="label">手数料</div>
              <div class="ipt" :class="{ black: numJP }">
                {{ numJP }} <span>円</span>
              </div>
            </div>
            <div class="item">
              <div class="label">国際送料</div>
              <div class="ipt" :class="{ black: freight }">
                {{ freight }}<span>円</span>
              </div>
            </div>
          </div>
          <p>※ 沖縄に配送する場合は、70元／箱の配送料をプラス</p>
        </div>
        <!-- 合计 -->
        <div class="total">
          <p>合计</p>
          <div class="ipt" :class="{ black: total }">
            {{ total }} <span>円</span>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import top from "../../components/head/Top.vue";
import Foot from "../../components/foot/Foot";
import { getRate } from "../../api/API/home";
import { freight } from "../../utlis/freight";
export default {
  components: {
    top,
    Foot,
  },
  data() {
    return {
      value: "",

      options: freight,
      price: "",
      num: "",
      priceJP: 0,
      numJP: 0,
      freight: 0,
      total: 0,
      rate: "",
    };
  },
  created() {
    var list = {
      mod: "inc",
      act: "ordersys",
      str: "getRate",
    };
    getRate(list).then((res) => {
      this.rate = res.data;
    });
  },
  methods: {
    calculatePrice() {
      console.log(this.num);
      this.priceJP = (this.rate * this.price * this.num).toFixed(0);

      this.calculateTotal();
    },
    calculateNum() {
      this.numJP = (this.num * 15 * this.rate).toFixed(0);
      this.calculatePrice();
    },
    calculateFreight(e) {
      this.freight = (e * this.rate).toFixed(0);
      this.calculateTotal();
    },
    calculateTotal() {
      this.total = this.priceJP - 0 + (this.numJP - 0) + (this.freight - 0);
    },
  },
};
</script>
<style lang='scss' scoped>
.body {
  width: 1200px;
  margin: 0 auto;

  .el-select {
    width: 100%;
  }

  /deep/.el-input__inner {
    height: 50px;
    border-radius: 10px;
  }

  h2 {
    font-size: 36px;
    margin: 80px 0 40px;
    text-align: center;
    font-weight: 600;
  }

  .head {
    p {
      font-size: 25px;
      line-height: 36px;
      margin-bottom: 10px;
    }
  }

  .main {
    border: 1px solid #ddd;
    border-radius: 20px;
    margin: 80px 0;
    padding: 0 300px;

    .label {
      font-size: 25px;
      border-left: 4px solid #f3c622;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      margin-bottom: 20px;
      font-weight: 600;
    }

    .row {
      margin-bottom: 40px;

      p {
        margin-bottom: 20px;
        font-size: 18px;
      }

      .ipt {
        input {
          height: 50px;
          width: 580px;
          padding: 0 10px;
          border-radius: 10px;
          border: 1px solid #dcdfe6;
          font-size: 18px;

          &:focus {
            border-color: #f3c622;
          }
        }
      }
    }

    .money {
      background-color: #fdf4d3;
      border-radius: 20px;

      padding: 40px 40px 0;
      margin-bottom: 40px;

      .money-box {
        overflow: hidden;

        .item {
          float: left;
          width: 240px;
          margin-bottom: 40px;

          &:nth-child(1) {
            margin-right: 38px;
          }

          .ipt {
            position: relative;
            background: #ffffff;
            border-radius: 10px;
            padding: 0 50px 0 10px;
            height: 50px;
            width: 170px;
            font-size: 18px;
            line-height: 50px;
            color: #dcdfe6;

            span {
              position: absolute;
              top: 0;
              right: 25px;
              font-size: 18px;
              color: #000;
            }
          }
        }
      }

      p {
        transform: translate(0, -20px);
      }
    }

    .total {
      padding: 40px;
      border-radius: 20px;
      background-color: #f3c622;
      margin-bottom: 80px;

      p {
        font-size: 25px;
        margin-bottom: 20px;
        font-weight: 600;
      }

      .ipt {
        position: relative;
        background: #ffffff;
        border-radius: 10px;
        padding: 0 50px 0 10px;
        height: 50px;
        width: 458px;
        font-size: 18px;
        line-height: 50px;
        color: #dcdfe6;

        span {
          position: absolute;
          top: 0px;
          right: 25px;
          font-size: 18px;
          color: #000;
        }
      }
    }
  }

  .black {
    color: #000 !important;
  }
}
</style>